document.addEventListener('DOMContentLoaded', () => {
  // 1) Irányítószám input megkeresése (több lehetséges selector)
  const zipInput =
    document.querySelector('input[autocomplete="postal-code"]') ||
    document.querySelector('input[name="zip"]') ||
    document.querySelector('#CartDeliveryZip') ||
    document.querySelector('input[id*="zip"]') ||
    document.querySelector('input[name*="zip"]');

  if (!zipInput) return;

  // 2) A meglévő üzenet doboz megkeresése (ami most zöldre vált)
  //    Ha nem találja, akkor létrehoz egyet ugyanoda.
  function getOrCreateMsgBox() {
    // próbáljuk a zip mező környékén megtalálni
    let box =
      zipInput.closest('.shopify-section')?.querySelector('.kc-zip-msg') ||
      zipInput.parentElement?.querySelector('.kc-zip-msg') ||
      zipInput.closest('div')?.querySelector('.kc-zip-msg');

    if (!box) {
      box = document.createElement('div');
      box.className = 'kc-zip-msg';
      // a mező alá tesszük, ahol logikusan van a mostani visszajelzés
      zipInput.insertAdjacentElement('afterend', box);
    }
    return box;
  }

  function showZipError(msg) {
    const box = getOrCreateMsgBox();
    box.textContent = msg;
    box.classList.add('is-error');
    box.classList.remove('is-success'); // ha lenne ilyen osztály
    zipInput.setAttribute('aria-invalid', 'true');
  }

  function clearZipErrorIfAny() {
    zipInput.removeAttribute('aria-invalid');
    const box =
      zipInput.closest('.shopify-section')?.querySelector('.kc-zip-msg') ||
      zipInput.parentElement?.querySelector('.kc-zip-msg');
    if (box) box.classList.remove('is-error');
  }

  // 3) Megrendelés / checkout gombok elkapása
  // Dawn-ben jellemző: form[action*="/cart"] + name="checkout"
  const cartForm =
    zipInput.closest('form') ||
    document.querySelector('form[action*="/cart"]') ||
    document.querySelector('form[action*="/checkout"]');

  if (!cartForm) return;

  cartForm.addEventListener('submit', (e) => {

  function isDeliverySelected() {
    const root = zipInput.closest('.shopify-section') || document;

    const deliveryBtn = Array.from(root.querySelectorAll('button, a, label'))
      .find(el => (el.textContent || '').toLowerCase().includes('kiszállítás'));

    const pickupBtn = Array.from(root.querySelectorAll('button, a, label'))
      .find(el => (el.textContent || '').toLowerCase().includes('átvétel'));

    const pickupActive =
      pickupBtn?.classList.contains('is-active') ||
      pickupBtn?.classList.contains('active') ||
      pickupBtn?.getAttribute('aria-pressed') === 'true' ||
      pickupBtn?.getAttribute('aria-selected') === 'true';

    if (pickupActive) return false;

    const deliveryActive =
      deliveryBtn?.classList.contains('is-active') ||
      deliveryBtn?.classList.contains('active') ||
      deliveryBtn?.getAttribute('aria-pressed') === 'true' ||
      deliveryBtn?.getAttribute('aria-selected') === 'true';

    if (deliveryBtn || pickupBtn) return !!deliveryActive;

    return false;
  }

  // ✅ itt a lényeg: MEGHÍVJUK
  if (!isDeliverySelected()) return;

  const val = (zipInput.value || '').trim();

  if (!val) {
    e.preventDefault();
    e.stopPropagation();

    showZipError('Kérlek add meg az irányítószámot a kiszállításhoz.');
    zipInput.focus();
    zipInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}, true);

  // gépelésre tűnjön el a piros állapot (és marad a ti beírás-közbeni validációtok)
  zipInput.addEventListener('input', () => clearZipErrorIfAny());
});

// 👇 opcionális: átvételre váltáskor töröljük a hibát
document.addEventListener('click', (e) => {
  const t = (e.target?.textContent || '').toLowerCase();
  if (t.includes('átvétel')) {
    clearZipErrorIfAny();
    const box = document.querySelector('.kc-zip-msg');
    if (box) box.textContent = '';
  }
});